var worlds = [
    {
        name:"Addition Alps",
        background:"world1.jpg",
        questionBackground:"alps.jpg",
        waypoints: [
            {x:96,y:1094},
            {x:381,y:1043,
                video:"addition.mp4",
                questions: [
                    {q:"What is 9 + 7?",o:["16","97","A Horse"],a:1},
                    {q:"Add 2 and 8",o:["32769","11","28"],a:2},
                ],
                xp:10,
            },

            {x:606,y:1117,
                questions: [
                    {q:"What is the next prime number after 7?",o:["11","17","43"],a:0},
                    {q:"The perimeter of a circle is known as what?",o:["Radius","Circumference","Fence"],a:1},
                ],
            },
            {x:752,y:934,
                questions: [
                    {q:"65-43 = ?",o:["108","57","22"],a:2},
                    {q:"True or False? A convex shape curves outwards",o:["True","False","Undecided"],a:0},
                ],
            },

            {x:941,y:923,
                questions: [
                    {q:"What does the square root of 144 equal?",o:["12","14","288"],a:0},
                    {q:"True or False? PI can correctly be written as a fraction",o:["True","False","Undecided"],a:1},
                ],
            },
            {x:1160,y:1001,
                questions: [
                    {q:"What comes after a million, billion and trillion?",o:["Marillion","Quadrillion","Fourty Two"],a:1},
                    {q:"52 divided by 4 equals what?",o:["12","13","14"],a:1},
                ],
            },
            {x:1211,y:842,
                questions: [
                    {q:"What is the bigger number?",o:["Google","Googol","Yahoo"],a:1},
                    {q:"True or False? Opposite sides of a parallelogram are equal",o:["True","False","Undecided"],a:0},
                ],
            },
            {x:1158,y:683,
                questions: [
                    {q:"87+56 = ?",o:["8756","127","143"],a:2},
                ],
            },
            {x:1076,y:711,
                questions: [
                    {q:"How many sides does a nonagon have?",o:["None","9","12"],a:1},
                    {q:"True or False? A convex shape curves outwards",o:["True","False","Undecided"],a:0},
                ],
            },
            {x:1003,y:827,
                questions: [
                    {q:"True or False? -2 is an integer",o:["True","False","Undecided"],a:0},
                ],
            },
            {x:734,y:788,
                questions: [
                    {q:"What is the next number in this sequence : 0,1,1,2,3,5,8,13,21,34?",o:["35","55","78"],a:1},
                ],
            },
            {x:448,y:778,
                questions: [
                    {q:"7 x 9 = ?",o:["63","64","65"],a:0},
                ],
            },
            {x:343,y:844,
                questions: [
                    {q:"True or False? In an isosceles triangle, all sides are unequal",o:["True","False","Undecided"],a:1},
                ],
            },
            {x:212,y:604,
                questions: [
                    {q:"In statistics, the middle value of an ordered set is called a what?",o:["Median","Medium","Onedian"],a:0},
                ],
            },
            {x:477,y:616,
                questions: [
                    {q:"What does 3 squared equal?",o:["6","3","9"],a:2},

                ],
            },
            {x:851,y:707,
                questions: [
                    {q:"True or False? -4 is a natural number",o:["True","False","Don't know"],a:1},
                ],
            },
            {x:965,y:600,
                questions: [
                    {q:"5 to the power of 0 is what?",o:["0","1","5"],a:1},

                ],
            },
            {x:840,y:490,
                questions: [
                    {q:"What is 8 - 4?",o:["5","7","4"],a:2},

                ],
            },
            {x:938,y:411,
                questions: [
                    {q:"How many 50p pieces are in £5?",o:["100","10","50"],a:1},
                    {q:"How many £2 coins in £100?",o:["50","20","100"],a:0},

                ],
            },
            {x:607,y:414,
                questions: [
                    {q:"What is 6106 + 1092?",o:["7190","7259","7198"],a:2},

                ],
            },
            {x:371,y:482,
                questions: [
                    {q:"What is 4000 - 2000?",o:["3000","2000","1000"],a:1},

                ],
            },
            {x:248,y:449,
                questions: [
                    {q:"What is 8 - 4?",o:["5","7","4"],a:2},

                ],
            },
            {x:184,y:378,
                questions: [
                    {q:"What is 72 divided by 8?",o:["9","8","7"],a:0},

                ],
            },
            {x:68,y:393,
                questions: [
                    {q:"5 quarter-hours = how many minutes?",o:["127","75","60"],a:1},

                ],
            },
            {x:158,y:271,
                questions: [
                    {q:"What is 8 + 8 - 4 x 2?",o:["24","32","48"],a:0},

                ],
            },
            {x:545,y:255,
                questions: [
                    {q:"How many hours in 3 days?",o:["24","48","72"],a:2},

                ],
            },
            {x:944,y:261,
                questions: [
                    {q:"What is 1pm in 24-hour time?",o:["13:00","17:00","01:00"],a:0},

                ],
            },
        ]
    }


]
